<template>
  <div>
    <v-breadcrumbs
      :items="[{ title: $t('memoru.albumList'), href: '/memoru/top', color:'primary' }, { title: '' }]"
      class="px-0"
    ></v-breadcrumbs>

    <h3>{{ $t('memoru.upload') }}</h3>

    <v-form v-model="isFormValid">
      <v-container class="pt-6">
        <v-row>
          <v-col cols="6">
            <h5>{{ $t('memoru.album') }}*</h5>
            <v-select
              :items="albums ? albums.items : []"
              v-model="input.albumId"
              :rules="[required]"
              item-title="title"
              item-value="albumId"
              variant="outlined"
              no-data-text="読み込み中..."
              :disabled="loading"
              hide-details
              density="compact"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h5>{{ $t('memoru.photoDate') }}*</h5>
            <v-text-field
              v-model="input.date"
              :rules="[required]"
              :disabled="loading"
              variant="outlined"
              hide-details
              density="compact"
              type="date"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <h5>{{ $t('memoru.category') }}*</h5>
            <v-select
              :items="multimediaCategoryType"
              :rules="[required]"
              v-model="input.category"
              :disabled="loading"
              variant="outlined"
              hide-details
              density="compact"
            ></v-select>
          </v-col>
        </v-row>
        <v-row @dragover.prevent @drop="onDrop">
          <v-col cols="6">
            <h5>{{ $t('common_actions.selectFile') }}*</h5>
            <v-file-input
              v-model="files"
              :disabled="loading"
              :rules="[required]"
              :label="$t('memoru.dragDropHint')"
              class="pt-1"
              variant="outlined"
              hide-details
              density="compact"
              height="120px"
              multiple
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row class="pt-6">
          <v-col cols="6">
            <v-btn
              @click="clickUpload"
              :loading="loading"
              :disabled="!isFormValid"
              color="primary"
              variant="flat"
              large
              block
            >
              {{ $t('memoru.upload') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { multimediaCategoryType } from "@/constants/memoru";
import { memoruModule } from "@/store/dataModules/memoruModule";
import LocalDataService from "@/service/LocalDataService";
import { MultimediaAlbumListResponse } from "chaild-api/lib";
import ValidationMixin from "@/mixins/ValidationMixin";
import { snackbarModule } from "@/store/viewModules/snackbarModule";
import ApiMemoru from "@/api/ApiMemoru";
import ApiResource from "@/api/ApiResource";

export default defineComponent({
  name: "MemoruUpload",

  mixins: [ValidationMixin],

  async mounted() {
    // TODO: paramsのalbumIdを見て初期値としてset
    await this.listAlbums();
  },

  data() {
    return {
      loading: false,
      isFormValid: false,
      multimediaCategoryType: multimediaCategoryType,
      input: {
        albumId: "",
        date: "",
        category: "photo" as "photo" | "movie",
      },
      files: [] as File[],
    };
  },

  computed: {
    albums: function (): MultimediaAlbumListResponse | null {
      return memoruModule.albums;
    },
  },

  methods: {
    async listAlbums() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await memoruModule.listAlbums({
          nurseryId,
          skip: 0,
          limit: 20000,
        });
      }
    },
    async clickUpload() {
      this.loading = true;
      for (const file of this.files) {
        // get presigned url
        const presignedResponse = await ApiMemoru.getPresignedUrl({
          ...this.input,
          filename: file.name,
        }).catch(() => (this.loading = false));

        if (presignedResponse) {
          const uploadResponse = await ApiResource.uploadFile({
            url: presignedResponse.preSignedUploadUrl,
            file: file,
          }).catch(() => (this.loading = false));
        }
      }
      snackbarModule.snackOn({
        message: this.$t('memoru.uploadStarted'),
      });
      this.loading = false;
      this.$router.push({ path: "/memoru/top" });
    },
    onDrop(values: any) {
      values.preventDefault();
      values.stopPropagation();
      const _files = values.dataTransfer.files;
      for (const file of _files) {
        this.files.push(file);
      }
    },
  },
});
</script>
